import type { SVGProps } from 'react'
const SvgSyChevronDownSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m23.1 7.4-2-2-9.1 9.1-9.1-9-2 2L12 18.6 23.1 7.5z" />
	</svg>
)
export default SvgSyChevronDownSystem
